import { Grid, ActionArea, Button, Caption } from '@design-systems/canvas-ui'
import { useNavigate } from 'react-router-dom'
import Icon, { CloseIcon } from '@design-systems/react-icons'
import styles from '../../pages/SearchResultsPage.module.css'
import {
  FEDERATED_DELETE_RECENTLY_SEARCHED,
  FEDERATED_GET_RECENT_SEARCHES,
  FEDERATED_ADD_RECENTLY_SEARCHED,
  RECENT_SEARCH_REFETCH_QUERIES,
} from '../../../../graphql/queries/globalSearch/recentSearchesQueries'
import type { RecentSearch } from '../../../../graphql/queries/globalSearch/recentSearchesQueries'
import { useMutation, useQuery } from '@apollo/client/react'
import { Spinner } from '@design-systems/canvas-ui'

interface RecentSearchesSideBarProps {
  recentSearches?: RecentSearch[]
  setHoverIndex: (index: number) => void
  hoverIndex: number
}

const RecentSearchesSideBar = ({
  setHoverIndex,
  hoverIndex,
}: RecentSearchesSideBarProps) => {
  const navigate = useNavigate()
  const [addRecentlySearched] = useMutation(FEDERATED_ADD_RECENTLY_SEARCHED, {
    refetchQueries: RECENT_SEARCH_REFETCH_QUERIES,
    awaitRefetchQueries: true,
  })

  const [deleteRecentSearch] = useMutation(FEDERATED_DELETE_RECENTLY_SEARCHED, {
    refetchQueries: RECENT_SEARCH_REFETCH_QUERIES,
    awaitRefetchQueries: true,
  })
  const { data, loading, error } = useQuery(FEDERATED_GET_RECENT_SEARCHES, {
    variables: { page: 0, size: 50 },
  })
  const recentSearches = data?.recentSearches?.content || []

  const handleDeleteRecentSearch = async (id: string) => {
    await deleteRecentSearch({ variables: { id } })
  }

  return (
    <Grid.Item
      className={`hc8-pa-4x ${styles.scrollableContent} ${styles.sideBarWidth}`}
    >
      <Grid.Item className="hc8-pv-2x">
        <strong>Recent searches</strong>
      </Grid.Item>
      {loading && !data && (
        <Grid.Container justify="center">
          <Spinner className="hc8-mt-2x" />
        </Grid.Container>
      )}
      {recentSearches.map((search: RecentSearch, index: number) => (
        <Grid.Container
          noWrap
          justify="space-between"
          key={index}
          onMouseEnter={() => setHoverIndex(index)}
          onMouseLeave={() => setHoverIndex(-1)}
        >
          <Grid.Item size={{ xs: 9 }}>
            <ActionArea
              corners="all"
              onClick={() => {
                addRecentlySearched({
                  variables: { searchTerm: search.searchTerm },
                })
                navigate('/searchResults/' + search.searchTerm)
              }}
            >
              <Grid.Item key={index} className="hc8-pa-2x">
                {search.searchTerm}
              </Grid.Item>
            </ActionArea>
          </Grid.Item>
          <Grid.Item size={{ xs: 3 }}>
            {hoverIndex === index && (
              <Button
                size="sm"
                variant="ghost"
                align="center"
                className="hc8-pv-4x"
                onClick={() => handleDeleteRecentSearch(search.id)}
              >
                <Icon svg={CloseIcon} />
              </Button>
            )}
          </Grid.Item>
        </Grid.Container>
      ))}
      {!recentSearches.length && !loading && !error && (
        <Grid.Item size={{ xs: 12 }} align="center" className="hc8-mt-2x">
          <em>No recent searches</em>
        </Grid.Item>
      )}
      {!loading && !data && error && (
        <Grid.Item>
          <Caption className="hc8-ta-center">
            <strong>Unable to load items</strong>
          </Caption>
        </Grid.Item>
      )}
    </Grid.Item>
  )
}

export default RecentSearchesSideBar
